import * as React from 'react';
import HelpOutlineIcon from '../../../../../components/Icons/HelpOutlineIcon';
import { OriginIconProps } from '../../../../../components/OriginIcon';
import PhoneIcon from '../../../../../components/Icons/PhoneIcon';
import BuildIcon from '../../../../../components/Icons/BuildIcon';
import FlatRoofIcon from '../../../../../components/Icons/FlatRoofIcon';
import PitchedRoofIcon from '../../../../../components/Icons/PitchedRoofIcon';
import HomeIcon from '../../../../../components/Icons/HomeIcon';
import CloseIcon from '../../../../../components/Icons/CloseIcon';

export interface SolarIconProps extends OriginIconProps {
  iconType: string;
}

export const SolarIcon: React.StatelessComponent<SolarIconProps> = (props: SolarIconProps) => {
  const { iconType, ...other } = props;
  switch (iconType) {
    case 'phone':
      return <PhoneIcon {...other} />;
    case 'helpOutline':
      return <HelpOutlineIcon {...other} />;
    case 'build':
      return <BuildIcon {...other} />;
    case 'flatRoof':
      return <FlatRoofIcon {...other} />;
    case 'pitchedRoof':
      return <PitchedRoofIcon {...other} />;
    case 'home':
      return <HomeIcon {...other} />;
    case 'close':
      return <CloseIcon {...other} />;
    default:
      return null;
  }
};
